<template>
    <section class="home-contest">
      <div class="container section-contest section-value-props hidden">
        <div class="section-header">
          <span class="subheading">{{$t('contests.title')}}</span>
          <h2 class="heading-secondary">{{$t('contests.header')}}</h2>
        </div>
        <div class="grid grid--3-cols">
          <div class="value-box hidden">
            <img src="/assets/invrs-contest1.png" class="value-icon" />
            <h3 class="heading-tertiary">{{$t('contests.skill')}}</h3>
            <p class="value-description">
              {{$t('contests.skillText')}}
            </p>
          </div>
          <div class="value-box hidden">
            <img src="/assets/invrs-contest2.png" class="value-icon" />
            <h3 class="heading-tertiary" v-html="$t('contests.motion')"></h3>
            <p class="value-description" v-html="$t('contests.motionText')">
             
            </p>
          </div>
          <div class="value-box hidden">
            <img src="/assets/invrs-contest3.png" class="value-icon" />
            <h3 class="heading-tertiary" v-html="$t('contests.challenge')"></h3>
            <p class="value-description" v-html="$t('contests.challengeText')">
            </p>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        valueProps: [],
        obsOptionsValueProps: {
          root: null,
          threshold: 0.3,
        },
        obsOptionsSection: {
          root: null,
          threshold: 0.15,
        },
        section: "",
      };
    },
    mounted() {
      this.valueProps = document.querySelectorAll(".home-contest .value-box");
      this.section = document.querySelector(".home-contest .section-value-props");
      const valuePropsObserver = new IntersectionObserver(
        this.revealValueProps,
        this.obsOptionsValueProps
      );
      const sectionObserver = new IntersectionObserver(
        this.revealSection,
        this.obsOptionsSection
      );
      valuePropsObserver.observe(this.section);
      sectionObserver.observe(this.section);
    },
    methods: {
      revealValueProps(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.valueProps.forEach((v, i) => {
              setTimeout(() => v.classList.remove("hidden"), i * 100);
            });
          }
        });
      },
      revealSection(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.section.classList.remove("hidden");
          }
        });
      },
    },
  };
  </script>
  
<style scoped>
section {
    padding: 9.6rem 0;
    position: relative;
}
.section-contest {
  max-width: 180rem;
  transition: all 0.3s ease-in;
}

.section-value-props {
  transition: all 0.3s ease-in;
}

.value-description {
  font-size: 1.8rem;
  line-height: 2.6rem;
}

.value-icon {
  margin-bottom: 1.6rem;
  width: 9.2rem;
  height: 10rem;
}

.section-header {
  display: flex;
  flex-direction: column;
}

.value-box {
  transition: all 0.3s ease-in;
}

.hidden {
    transform: translateY(4.8rem);
    opacity: 0;
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
    .value-icon {
    margin-bottom: 1.6rem;
    width: 6.4rem;
    height:6.4rem;
    }
}

  
  </style>
  